<template>
  <div>
    <h1 class="page-title">{{ $t("catalogue.properties.title") }}</h1>
  </div>
    <div class="flex justify-end ml-auto">
        
        <Button
             @click="$router.push('/admin/properties/create')"
            label="Ajouter une propriété"           
            icon="pi pi-plus"
            class="button-add"
        />
            
    </div>
  <div class="card">
    <DataTable
      :value="tableData"
      :rows="rows"
      :paginator="true"
      :loading="isLoading"
      :rowsPerPageOptions="rowsPerPageOptions"
      lazy
      @page="onPaginate"
      :currentPage="currentPage"
      :totalRecords="totalRecords"
    >
      <template #header>
        <div class="flex search-container">
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="criteria"
              @keyup.enter="onFilterDt"
              @input="onClearInputFilter"
              class="w-64"
              placeholder="Rechercher une propriété"/>
          </span>
            
        </div>
      </template>
      <div class="card-body pt-0">
        <Column field="name" header="Nom de la propriété" class="whitespace-nowrap"/>
        <Column field="createdAt" header="Date de création" class="whitespace-nowrap">
          <template #body="slotProps">
            {{ slotProps.data.createdAt }}
          </template>
        </Column>        
        <Column field="createdBy.uuid" header="Créé par">
          <template #body="slotProps">
            {{ slotProps.data.createdBy }}
          </template>
        </Column>
        <Column field="status" header="État">
          <template #body="slotProps">
            <div v-if="slotProps.data.status" class="badge border-white text-green-800 bg-green-200 p-4">Actif</div>
            <div v-else class="badge border-white text-red-800 bg-red-200 p-4">Inactif</div>
          </template>
        </Column>
        <Column headerStyle="width: 12em;">
          <template #header>
            <div>Actions</div>
          </template>
          <template #body="slotProps">
              <Button
                  size="small"
                  icon="pi pi-eye"
                  class="p-button-success p-button-eye"
                  :class="`${slotProps.data.uuid}`"
                  style="margin-right: 0.5em"
                  title="voir les valeurs de propriété"
                  @click="listPropertyValue(slotProps.data.uuid)"
              />
          </template>
        </Column>
      </div>
      <template #empty>Aucun résultat trouvé.</template>
    </DataTable>
  </div>
</template>

<script lang="ts" setup>
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Property from "@/models/product/property/Property";
import { ref, onMounted } from "vue";
import {fetchProperties} from "@/_services/property/property";
import router from "@/router";

const page = ref < number > (1);
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const properties = Array<Property>();
const tableData = ref<Array<Property>>(properties);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const totalRecords = ref<number>(0);

const editProperty = (propertyUuid: string) => {
  router.push({ name: 'customPropertiesEdit', params: { uuid: propertyUuid } });
};

const listPropertyValue = (propertyUuid: string) => {
    router.push({ name: 'CustomPropertyValuesList', params: { uuid: propertyUuid } });
};

onMounted(async () => {
    await populateDatatable(rows.value, page.value, criteria.value);
});

const populateDatatable = async (itemsPerPage: number, page: number, criteria: string) => {
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchProperties(itemsPerPage, page, criteria);
    totalRecords.value = totalRecordsDt;
    isLoading.value = loadingDt;
    tableData.value = tableDataDt;
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    await populateDatatable(e.rows, e.page + 1, criteria.value);
};

const onFilterDt = async () => {
    if (criteria.value != "") {
        await populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onClearInputFilter = async () => {
    if (criteria.value === "") {
        await populateDatatable(rows.value, page.value, "");
    }
};


</script>
